package com.vizio.redwolf.consent.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ConsentFailureMessage(
    val message: String
)
